import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient — OPTIMISATION.md Phase 2 [F].
 *
 * Defaults (per the optimisation doc §4):
 *  - staleTime 30s            → cheap to reuse, fresh enough for production data;
 *                               revisits within 30s hit cache (0 network).
 *  - gcTime 5min              → keep data in memory for instant back-navigation.
 *  - refetchOnWindowFocus     → RQ checks staleTime first, so this is cheap.
 *  - retry 1 (queries)        → one retry for transient network blips.
 *  - mutations retry 0.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
